/**
 * 校验手机号
 * @param {*} tel 手机号码
 */
export function validatePhoneNumber(tel) {
	let reg =
		/^(?:(?:\+|00)86)?1(?:(?:3[\d])|(?:4[5-7|9])|(?:5[0-3|5-9])|(?:6[5-7])|(?:7[0-8])|(?:8[\d])|(?:9[1|8|9]))\d{8}$/
	if (tel === '' || !reg.test(tel)) {
		return false
	} else {
		return true
	}
}


// 防抖
export function _debounce(fn, delay) {

	var delay = delay || 200;
	var timer;
	return function() {
		var th = this;
		var args = arguments;
		if (timer) {
			clearTimeout(timer);
		}
		timer = setTimeout(function() {
			timer = null;
			fn.apply(th, args);
		}, delay);
	};
}

// 节流
export function _throttle(fn, interval) {
	var last;
	var timer;
	var interval = interval || 200;
	return function() {
		var th = this;
		var args = arguments;
		var now = +new Date();
		if (last && now - last < interval) {
			clearTimeout(timer);
			timer = setTimeout(function() {
				last = now;
				fn.apply(th, args);
			}, interval);
		} else {
			last = now;
			fn.apply(th, args);
		}
	}
}


// 时间格式化
export function formatTime(date) {
	const year = date.getFullYear()
	const month = date.getMonth() + 1
	const day = date.getDate()
	const hour = date.getHours()
	const minute = date.getMinutes()
	const second = date.getSeconds()

	// return `${[year, month, day].map(formatNumber).join('/')} ${[hour, minute, second].map(formatNumber).join(':')}`
	return `${[year, month, day].map(formatNumber).join('-')}`
}
// 时间格式化
export function formateDate(timestamp) {
	// 计算年月日时分的函数
	var date = new Date(timestamp)
	var Y = date.getFullYear() + '-'
	var M = (date.getMonth() + 1) + '-'
	var D = date.getDate() + ' '
	var h = date.getHours() + ':'
	var m = date.getMinutes() + ':'
	var s = date.getSeconds()
	return Y + M + D + h + m + s
}

const formatNumber = n => {
	n = n.toString()
	return n[1] ? n : `0${n}`
}


export function newGuid(timestamp) {
	return (S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4());
}
//JS生成GUID函数,类似.net中的NewID();
function S4() {
	return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
}